import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "react-hot-toast";
import App from "./App.tsx";
import "./index.css";
import { Consent } from "./components/Consent";

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <BrowserRouter>
            <Consent>
                <HelmetProvider>
                    <App />
                    <Toaster position="top-center" />
                </HelmetProvider>
            </Consent>
        </BrowserRouter>
    </React.StrictMode>
);
